module.exports = __webpack_public_path__ + "static/media/0b.34eec106.jpg";